import { Bill } from './bill.model';
import { isEditableFinancialDraft } from '../../shared/accounting-draft-eligibility';

/** Matches PATCH bills/{billId}, including generated drafts. */
export function canEditNonPoBillDraft(bill: Bill | null | undefined, owningCompanyId?: number): boolean {
    return !!bill?.billId && owningCompanyId != null && isEditableFinancialDraft(bill, owningCompanyId);
}
